import React, { useState, useEffect, useContext } from 'react';
import { USBGrid, USBColumn, USBButton, USBSelect } from '@usb-shield/components-react';
import { ShieldTable } from '../../../components/shared/Table';
import { endpoints } from '../../../../config/connections';
import USBBreadcrumb from '@usb-shield/components-react/dist/cjs/breadcrumb';
import Loader from '../../../components/utilities/Loader';
import '@usb-shield/react-forms-base/dist/library/styles/index.css';
import '../VendorUserReport/vendor-user.css';
import callApi from '../../../components/utilities/callApi';
import moment from 'moment';
import { ExportToExcel } from '../../../components/utilities/ExportToExcel';
import useUserRole from '../../../components/Hooks/use-UserRole';
import _noaccess from '../../../pages/_noaccess'
import { USBFormsHelperText } from '@usb-shield/react-forms-base';
import { downloadReport } from '../../../components/utilities/Utils';

const VendorUser = () => {
  const [fullData, setFullData] = useState(null);
  const [vendorCompanyNameList, setVendorCompanyNameList] = useState([]);
  const [vendorUserNameList, setVendorUserNameList] = useState([]);
  const [vendorCompanyDataList, setVendorCompanyDataList] = useState([]);
  const [vendorList, setVendorList] = useState([]);
  const [vendorListImmutable, setVendorListImmutable] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [companySelections, setCompanySelections] = useState(null);
  const [keyword, setKeyword] = useState("");
  const [filterSelections, setfilterSelections] = useState({ user: '', company: '' })
  // const [clearFilterFlag, setClearFilterFlag] = useState(false);

  const normalizeValue = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'string' && value.trim() === '') return '-';
    return value;
  };

  const formatUsers = (users = []) => {
    return users.map((user) => {
      const formattedUser = {};

      Object.keys(user).forEach((key) => {
        formattedUser[key] = normalizeValue(user[key]);
      });

      return formattedUser;
    });
  };
  
  const getFilterData = () => {
    setLoading(true);
    const url = `${endpoints.apigee}/document-management/coreservice/user-management/v1/vendors/details`;
    callApi
      .getApiData(url)
      .then((response) => {
        if (response.status === 200) {
          setResponseData(response?.data);
          loadVendorDropdown(response?.data);
        }
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  const getVendorUserNames = async (selectionsParam) => {
    setLoading(true);
    const url = `${endpoints.apigee}/document-management/coreservice/user-management/v1/vendor/user/report?vendorNumber=${selectionsParam}`;
    try {
      const response = await callApi.getApiData(url);
      if (response) {
        setFullData(response);
        const formattedUsers = formatUsers(response.data?.users);
        setVendorUserNameList(formatFilterUser(formattedUsers));
        setVendorCompanyDataList(formatFilterCompanyName(formattedUsers));
        setVendorList(formattedUsers);
        setVendorListImmutable(formattedUsers);
        setLoading(false);
      }
    } catch (e) {
      setLoading(false);
    }

  };

  const loadVendorDropdown = (response) => {
    const parentCompanyTemp = [];
    response.forEach((element) => {
      parentCompanyTemp.push(element.vendorName);
    });
    setVendorCompanyNameList(formatFilterData(parentCompanyTemp, 0));
    setLoading(false);
  };

  const handleSearch = (value) => {
    setKeyword(value)
    if (value.length > 0) {
      setVendorList(vendorListImmutable.filter(obj =>
        obj.companyName.toLowerCase().includes(value.toLowerCase()) ||
        obj.emailAddress.toLowerCase().includes(value.toLowerCase()) ||
        obj.legalEntity?.toLowerCase().includes(value.toLowerCase()) ||
        obj.deals.toLowerCase().includes(value.toLowerCase()) ||
        obj.role?.toLowerCase().includes(value.toLowerCase()) ||
        obj.documentType.toLowerCase().includes(value.toLowerCase())
      ));
    }
    else {
      setVendorList(vendorListImmutable);
    }
  }

  const formatFilterCompanyName = (list) => {
    setKeyword('')
    const companyList = [];
    const uniqueParentCompanyList = list.filter((value, index, self) =>
      index === self.findIndex((item) => (item.companyName === value.companyName))
    )
    uniqueParentCompanyList.forEach((element, index) => {
      companyList.push({ content: element.companyName, value: element.companyName })
    });
    const sortedData = companyList.sort((a, b) =>
      a.content.localeCompare(b.content)
    );
    sortedData.unshift({ value: '', content: 'Select' });
    return sortedData;
  };

  // to format data of vendor user dropdown
  const formatFilterUser = (list) => {
    const newData = [];
    const uniqueUserList = list.filter((value, index, self) =>
      index === self.findIndex((item) => (item.firstName + item.lastName === value.firstName + value.lastName))
    )
    uniqueUserList.forEach((element, index) => {
      newData.push({ content: element.firstName + element.lastName, value: element.user });
    });
    const sortedData = newData.sort((a, b) =>
      a.content.localeCompare(b.content)
    );
    sortedData.unshift({ value: '', content: 'Select' });
    return sortedData;
  };

  // To format data of vendor dropdown
  const formatFilterData = (list, indicator) => {
    const newData = [];
    list.forEach((element, index) => {
      if (element !== null && element !== undefined) {
        newData.push({ value: index, content: element });
      }

    });
    const sortedData = newData.sort((a, b) =>
      a.content.localeCompare(b.content)
    );
    sortedData.unshift({ value: '', content: 'Select' });
    return sortedData;
  };

  const onVendorCompanyChange = (event, filterName) => {
    if (event?.nativeEvent?.type === 'change') {
      setfilterSelections({ user: '', company: '' })
      setVendorListImmutable([])
      setVendorList([])
      setVendorUserNameList([]);
      setVendorCompanyDataList([]);
      setCompanySelections(event?.target?.value);
      if (event.errorCode != 224) {
        const eventValue = event.target.value;
        const data = responseData[eventValue]?.vendorNumber;
        const companyname = responseData[eventValue]?.vendorName;
        getVendorUserNames(data);
      }
    }
  };

  const downloadVendorUserReport = () => {
    const excelData = [];
    const filterSelectionsTemp =
      `Filter selections : Vendor Company = ${companySelections} Vendor Users = ${filterSelections.user} Company Name = ${filterSelections.company}` + '';
    const columnName = {
      ' ': 'FIRST NAME',
      '  ': 'LAST NAME',
      '   ': 'EMAIL ADDRESS',
      '    ': 'ROLE',
      '     ': 'STATUS',
      '      ': 'COMPANY NAME',
      '       ': 'LEGAL ENTITY',
      '        ': 'DEALS',
      '         ': 'DOCUMENT TYPE'
    };
    const headersFields = [
      'firstName',
      'lastName',
      'emailAddress',
      'role',
      'status',
      'companyName',
      'legalEntity',
      'deals',
      'documentType'
    ]
    downloadReport(vendorList, filterSelectionsTemp, columnName, headersFields, 'Vendor User')
    // if (vendorList) {
    //   vendorList.forEach((item, index) => {
    //     if (index == 0) {
    //       excelData.push(
    //         {
    //           '': filterSelectionsTemp,
    //         },
    //         { '': '' },

    //       );
    //     }
    //     excelData.push({
    //       '': item.firstName,
    //       '  ': item.lastName,
    //       '   ': item.emailAddress,
    //       '    ': item.role,
    //       '     ': item.status,
    //       '      ': item.companyName,
    //       '       ': item.legalEntity.substring(0, 32766),
    //       '        ': item.deals.substring(0, 32766),
    //       '         ': item.documentType
    //     });
    //   });
    // }
    // ExportToExcel(
    //   Object.values(excelData),
    //   'Vendor User ' +
    //   moment().format('MMM DD, YYYY'),
    //   ()=>{},
    //   ()=>{}
    // );
  }

  const filterVendorData = (event, filterName) => {
    // setLoading(true)
    if (event?.nativeEvent?.type === 'change') {
      const eventValue = event?.target?.value?.trim() || '';
      let selection = { user: '', company: '' }
      if (filterName === "vendorUser") {
        selection.user = eventValue
        selection.company = filterSelections.company
      } else if (filterName === "vendorCompany") {
        selection.company = eventValue
        selection.user = filterSelections.user
      }
      setfilterSelections(selection)
      let filterFn;
      if (selection.user !== '' && selection.company !== '') {
        filterFn = (item) => item.user == selection.user && item.companyName == selection.company
      } else if (selection.user == '' && selection.company !== '') {
        filterFn = (item) => item.companyName == selection.company
      } else if (selection.user !== '' && selection.company == '') {
        filterFn = (item) => item.user == selection.user
      } else {
        filterFn = (item) => item
      }
      const filteredData = vendorListImmutable.filter(filterFn)
      setVendorList(filteredData)
    }
  }


  useEffect(() => {
    getFilterData();
  }, []);

  const tempUserRole = useUserRole();
  const columns = [{
    headerName: 'First Name',
    key: 'firstName',
    dataType: 'string',
    sortable: true,
  },
  {
    headerName: 'Last Name',
    key: 'lastName',
    dataType: 'string',
    sortable: true,
  },
  {
    headerName: 'Email Address',
    key: 'emailAddress',
    dataType: 'string',
    sortable: true,
  },
  {
    headerName: 'Role',
    key: 'role',
    dataType: 'string',
    sortable: true,
  },
  {
    headerName: 'Status',
    key: 'status',
    dataType: 'string',
    sortable: true,
  },
  {
    headerName: 'Company Name',
    key: 'companyName',
    dataType: 'string',
    sortable: true,
  },
  {
    headerName: 'Legal Entity',
    key: 'legalEntity',
    dataType: 'string',
    sortable: true,
    render: (value, row) => {
      return <>
        <span>
          {row.legalEntity.split("|").map((item, index) => (
            <>
              <strong>{item.split(":")[0]}</strong>{item.split(":")[1]}

              {row.legalEntity.split("|").length > (index + 1) ? (<hr />) : null}
            </>
          ))}
        </span>
      </>

    }
  },
  {
    headerName: 'Deals',
    key: 'deals',
    dataType: 'string',
    sortable: true,
    render: (value, row) => {
      return <>
        <span>
          {row.deals.split("|").map((item, index) => (
            <>
              <strong>{item.split(":")[0]}</strong>{item.split(":")[1]}
              {row.deals.split("|").length > (index + 1) ? (<hr />) : null}
            </>
          ))}
        </span>
      </>
    }
  },
  {
    headerName: 'Document Type',
    key: 'documentType',
    dataType: 'string',
    sortable: true,
    render: (value, row) => {
      return <>
        <span>
          {row?.documentType?.split("|").map((item, index) => (
            <>
              {item.length > 1 ? <li>{item}</li> : ''}
            </>
          ))}
        </span>
      </>
    }
  },]

  return (
    tempUserRole && tempUserRole != "employee" ? <_noaccess /> :
      <>
        <USBGrid addClasses="content-frame">
          <USBColumn largeSpan={8}>
            <USBBreadcrumb
              id="reports"
              text="Reports"
              breadcrumbs={[
                { id: 1, text: 'Reports', href: '/Reports/VendorUserFilter' },
                { id: 2, text: 'Vendor User', href: '' },
              ]}
            />
          </USBColumn>
          <USBColumn largeSpan={8}></USBColumn>
        </USBGrid>
        <USBGrid addClasses="content-frame content-bg">
          {loading ? <Loader /> : null}
          <USBColumn largeSpan={16}>
            <h1 className="heading-h1">Report: Vendor User</h1>
            <div className="page-details-wrap-vendor-user">
              <div className="page-details-container-vendor-user">Select Filters</div>
            </div>

            <div className="sorting-inputs-vendor-user">
              <div className="filter-dropdowns-vendor-user">
                {vendorCompanyNameList.length > 0 ? (
                  <USBSelect
                    id="companyName"
                    name="vendorUserCompany"
                    labelText="Vendor Company"
                    optionsArray={vendorCompanyNameList}
                    handleChange={(event) => {
                      onVendorCompanyChange(event, 'vendorNumber');
                    }}
                    initValue={companySelections}
                  />
                ) : (
                  null
                )
                }
              </div>
              <div className="filter-dropdowns-vendor-user">
                {vendorUserNameList.length > 0 ? (
                  <div>
                    <USBSelect
                      id="vendorUser"
                      name="vendorUserParentUser"
                      labelText="Vendor User"
                      optionsArray={vendorUserNameList}
                      handleChange={(event) => {
                        filterVendorData(event, 'vendorUser');
                      }}
                      initValue=""
                    />
                    <USBFormsHelperText labelFor="business-structure" />
                  </div>
                ) : (
                  null
                )}
              </div>
              <div className="filter-dropdowns-vendor-user">
                {vendorCompanyDataList.length > 0 ? (
                  <div>
                    <USBSelect
                      id="VendorcompanyName"
                      name="vendorUserParentCompany"
                      labelText="Parent Company"
                      optionsArray={vendorCompanyDataList}
                      handleChange={(event) => {
                        filterVendorData(event, 'vendorCompany');
                      }}
                      initValue=""
                    />
                    <USBFormsHelperText labelFor="business-structure">
                    </USBFormsHelperText>
                  </div>
                ) : (
                  null
                )}
              </div>
              {vendorUserNameList.length > 0 ? (
                <div>
                  <USBButton
                    addClasses="report-action-buttons"
                    id="downloadReport"
                    name="downloadReport"
                    variant="primary"
                    handleClick={() => downloadVendorUserReport()}
                  >
                    Download Report
                  </USBButton>
                </div>) : (null)}
              {vendorUserNameList.length > 0 ? (
                <div>
                  <USBButton
                    type="button"
                    addClasses="report-action-buttons"
                    id="clearFilterVendor"
                    name="clearfilter"
                    handleClick={() => {
                      setfilterSelections({ user: '', company: '' })
                      setVendorListImmutable([])
                      setVendorCompanyNameList([]);
                      setVendorUserNameList([]);
                      setVendorCompanyDataList([]);
                      setVendorList([]);
                      setKeyword('');
                      setCompanySelections(null)
                      getFilterData();
                    }}
                  >
                    Clear filters
                  </USBButton>
                </div>
              ) : (
                null
              )}
            </div>

            {vendorListImmutable.length > 0 ? (
              <div className="col lg-16  md-16  sm-16  display-flex  zero-padding  justify-auto  align-auto">
                <div className='vendor-user-search-container'>
                  <input
                    type="search"
                    className='input-search'
                    id='seachData'
                    placeholder="Search by company name, legal entities, deals, role or document types."
                    value={keyword}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <br /><br />
                  {vendorList.length > 0 ? (vendorList.length + " records found.") : "No Records Found"}
                  <br />

                </div>

                {vendorList.length > 0 ? (
                  <div className='vendor-user-page-content'>
                    <ShieldTable
                      data={vendorList}
                      columns={columns}
                      defaultSort={{ key: 'firstName', direction: 'asc' }}
                      pagination={{ pageSize: 10 }}
                      className="usb-theme"
                      emptyMessage="No vendor user records found"
                    />
                  </div>

                ) : (
                  null
                )}
              </div>
            ) : (
              null
            )}
          </USBColumn>
        </USBGrid>
      </>
  );
};

export default VendorUser;
